import Overlay from "ol/Overlay";
import { checkIconSvg, copyIconSvg } from "../../../../../../assets/icons";
import { focusOverlayInState } from "../overlayState";

type LocationInfoOverlayData = {
    title?: string;
    latitude: number;
    longitude: number;
    road?: string;
    path?: string;
    maintenancePosition?: string;
    kmM?: string;
};

async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            textarea.style.top = "-9999px";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(textarea);
            return ok;
        } catch {
            return false;
        }
    }
}

function formatCoord(value: number) {
    return Number.isFinite(value) ? value.toFixed(8) : String(value);
}

export function buildLocationInfoOverlay(overlayId?: string | number, data?: LocationInfoOverlayData) {

    const element = document.createElement("div");
    element.className = "ol-popup ol-popup--location-info";
    element.onclick = (event) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest("button")) return;
        focusOverlayInState(overlayId);
    };

    const content = document.createElement("div");
    content.className = "ol-popup__content";

    if (data?.title) {
        const titleEl = document.createElement("div");
        titleEl.className = "ol-popup__title";
        titleEl.textContent = data.title;
        content.appendChild(titleEl);
    }

    const rows = document.createElement("div");
    rows.className = "ol-popup__rows";

    const addRow = (label: string, value?: string) => {
        if (!value) return;
        const row = document.createElement("div");
        row.className = "ol-popup__row";
        row.style.display = "flex";
        row.style.alignItems = "flex-start";
        row.style.justifyContent = "space-between";
        row.style.gap = "8px";

        const leftContainer = document.createElement("span");
        leftContainer.className = "ol-popup__label";
        leftContainer.textContent = label;
        leftContainer.style.flexShrink = "0";
        leftContainer.style.marginTop = "3px";

        const middleContainer = document.createElement("div");
        middleContainer.style.textAlign = "right";
        middleContainer.style.flex = "1";
        middleContainer.style.minWidth = "0";
        middleContainer.style.wordBreak = "break-word";
        middleContainer.style.lineHeight = "1.4";

        const rightContainer = document.createElement("div");
        rightContainer.style.display = "flex";

        const valueSpan = document.createElement("span");
        valueSpan.className = "ol-popup__value";
        valueSpan.textContent = value;

        const copyBtn = document.createElement("button");
        copyBtn.type = "button";
        copyBtn.className = "ol-popup__row-copy-btn";
        copyBtn.innerHTML = copyIconSvg;
        copyBtn.title = "Скопировать";
        copyBtn.style.display = "inline-block";
        copyBtn.style.verticalAlign = "middle";
        copyBtn.style.background = "none";
        copyBtn.style.border = "none";
        copyBtn.style.cursor = "pointer";
        copyBtn.style.padding = "2px";
        copyBtn.style.color = "#666";
        copyBtn.style.transition = "color 0.2s";
        copyBtn.style.lineHeight = "0";

        copyBtn.onmouseenter = () => { copyBtn.style.color = "#000"; };
        copyBtn.onmouseleave = () => { copyBtn.style.color = "#666"; };

        copyBtn.onclick = async () => {
            const ok = await copyToClipboard(value);
            if (ok) {
                copyBtn.innerHTML = checkIconSvg;
                copyBtn.style.color = "green";
                setTimeout(() => {
                    copyBtn.innerHTML = copyIconSvg;
                    copyBtn.style.color = "#666";
                }, 1200);
            }
        };

        middleContainer.appendChild(valueSpan);
        rightContainer.appendChild(copyBtn);

        row.appendChild(leftContainer);
        row.appendChild(middleContainer);
        row.appendChild(rightContainer);
        rows.appendChild(row);
    };

    const lat = data?.latitude;
    const lon = data?.longitude;
    if (typeof lat === "number" && typeof lon === "number") {
        addRow("Координаты", `${formatCoord(lat).replace('.', ',')} ${formatCoord(lon).replace('.', ',')}`);
    }
    addRow("Дорога", data?.road);
    addRow("Направление", data?.path);
    addRow("Экспл. км+м", data?.maintenancePosition);
    addRow("Км+м", data?.kmM);

    content.appendChild(rows);
    element.appendChild(content);

    const overlay = new Overlay({
        element,
        positioning: "bottom-center",
        offset: [0, -18],
        stopEvent: true,
        insertFirst: false,
    });

    return overlay;
}
